import { render } from "./FixedNavbar.vue?vue&type=template&id=0689c5bc"
import script from "./FixedNavbar.vue?vue&type=script&lang=js"
export * from "./FixedNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__